module.exports = __webpack_public_path__ + "src/assets/img/tonext.8509e7ce.png";